<template>
  <div class="timecard-order-list">
    <Row>
      <Col :xs="24" :sm="12">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <DatePicker
              type="daterange"
              format="yyyy-MM-dd"
              split-panels
              @on-change="changeDate"
              style="width: 200px"
              placeholder="开始时间 - 结束时间"
            ></DatePicker>
          </FormItem>
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="支付订单号或手机号..."></Input>
          </FormItem>
          <FormItem>
            <Input v-model="formItem.venue" clearable placeholder="场馆名称..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "timecard-order-list",
  data() {
    return {
      loading: true,
      dataloading: true,
      exportLoading: false,
      datetime: [],
      title: "",
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "次卡名称",
          key: "timecardname",
          fixed: "left",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.timecard != null ? params.row.timecard.name : ""
              )
            ]);
          }
        },
        {
          title: "是否通票",
          key: "is_through_ticket",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.is_through_ticket == 0 ? "否" : "是")
            ]);
          }
        },
        {
          title: "订单号",
          key: "order_sn",
          minWidth: 150
        },
        {
          title: "支付订单号",
          key: "pay_order_num",
          minWidth: 150
        },
        {
          title: "购买人",
          key: "name",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.user != null ? params.row.user.username : ""
              )
            ]);
          }
        },
        {
          title: "场馆",
          key: "name",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.venue != null ? params.row.venue.title : ""
              )
            ]);
          }
        },
        {
          title: "剩余次数",
          key: "times",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.usertimecard != null
                  ? params.row.times - params.row.usertimecard.used_times
                  : params.row.times
              )
            ]);
          }
        },
        {
          title: "使用次数",
          key: "times",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.usertimecard != null
                  ? params.row.usertimecard.used_times
                  : 0
              )
            ]);
          }
        },
        {
          title: "次卡金额",
          key: "price",
          width: 150
        },
        {
          title: "支付状态",
          key: "pay_status",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.pay_status == 0
                  ? "未支付"
                  : params.row.pay_status == 1
                  ? "支付中"
                  : "已完成"
              )
            ]);
          }
        },
        {
          title: "支付时间",
          key: "pay_at",
          width: 150
        },
        {
          title: "订单状态",
          key: "name",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == 0 ? "取消" : "正常")
            ]);
          }
        },
        {
          title: "购买时间",
          key: "created_at",
          width: 150
        }
        // {
        //   title: "操作",
        //   key: "action",
        //   width: 250,
        //   align: "left",
        //   fixed: "right",
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           props: {
        //             type: "primary",
        //             size: "small"
        //           },
        //           style: {
        //             marginRight: "5px"
        //           },
        //           on: {
        //             click: () => {
        //               this.detail(params.row.id); //订单
        //             }
        //           }
        //         },
        //         "详情"
        //       )
        //     ]);
        //   }
        // }
      ],
      tablelist: [],
      tableTeamuserlist: [],
      tableServicelist: [],
      tableReceperlist: [],
      dataInfo: {},
      review: {},
      fileList: [],
      leadIn: {
        filePath: ""
      },
      showTeamModalStatus: false,
      showImportModalStatus: false,
      showEditInfoStatus: false
    };
  },
  // 组件
  components: {},
  created: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.smartorder
        .timecardorder({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
    },
    //订单
    detail(id) {
      this.title = "订单详情";
      this.showTeamModalStatus = !this.showTeamModalStatus;
      this.$api.smartorder.orderdetail({ id: id }).then(res => {
        this.dataInfo = res.result.orders_info;
        this.tableTeamuserlist = res.result.orders_team_user;
        this.tableServicelist = res.result.orders_services;
        this.tableReceperlist = res.result.smartpark_order_receper;
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    changeDate(val) {
      this.datetime = val;
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var starttime = this.datetime[0] != undefined ? this.datetime[0] : "";
      var endtime = this.datetime[1] != undefined ? this.datetime[1] : "";
      var ps = {
        starttime: starttime,
        endtime: endtime,
        key: this.formItem.key,
        venue: this.formItem.venue,
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.smartorder.timecardorder(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
    }
  }
};
</script>